import BasketSummarySFC from "./BasketSummary.vue";
export const BasketSummary = BasketSummarySFC;
